import qs from 'qs'
import axios from 'axios'

export const loginService = ({
  login (username, password) {
    var loginObjToPost = { userName: username, Password: password, grant_type: 'password' }
    return axios.post('/token', qs.stringify(loginObjToPost))
  },
  resetPassword (userName, useEmail) {
    return axios.post('/api/UserProfile/ResetPassword?userName=' + userName + '&useEmail=' + useEmail, null)
  },
  resetPasswordUsingKey (userKey, password) {
    var userObj = {PasswordKey: userKey, Password: password}
    var stringifiedObj = qs.stringify(userObj)
    return axios.put('/api/UserProfile/updatePassword', stringifiedObj, null)
  }
})



// WEBPACK FOOTER //
// ./src/server-util/login-service.js